// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/main.scss
// module id = ./src/sass/main.scss
// module chunks = 7